import { useEffect } from "react";
import { useGetUser } from "../auth/useGetUser";
import { initAdtraceWithExternalId } from "../../lib/adtrace";
import { isAdtraceAllowed } from "../../features/analytics/adtraceEnabled";

export default function AdtraceGate() {
  const { isPending, isError, user } = useGetUser();

  useEffect(() => {
    if (isPending) return;
    if (!isAdtraceAllowed()) return;

    const userId = !isError && user?.id != null ? String(user.id) : undefined;

    if (userId) {
      initAdtraceWithExternalId(userId); // sets/overwrites externalDeviceId
    }
  }, [isPending, isError, user?.id]);

  return null;
}
